export default "__VITE_ASSET__BjiKO72h__"